<template>
  <div class="page">
    <div class="card">
      <div class="header">
        <h1 class="title">全部患者</h1>
        <div class="total">共{{ list.length }}人</div>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th>患者名称</th>
            <th>病例</th>
            <th>访问链接</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="loading">
            <td colspan="3" class="muted">加载中...</td>
          </tr>
          <tr v-else-if="list.length === 0">
            <td colspan="3" class="empty-cell">无数据</td>
          </tr>
          <tr v-else v-for="(item, idx) in list" :key="idx">
            <td>
              <div class="name">{{ item.patientName }}</div>
            </td>
            <td>
              <div class="record" :title="item.illness">{{ item.illness }}</div>
            </td>
            <td>
              <a class="link" :href="toAbsoluteUrl(item.url)" target="_blank" rel="noopener noreferrer">查看</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  
</template>

<script>
import axios from 'axios'

export default {
  name: 'AllPatients',
  data() {
    return {
      list: [],
      loading: false,
      error: ''
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      this.error = ''
      try {
        const resp = await axios.get('https://catalog.lianty.cn/mdt/medical/show/all')
        const data = resp && resp.data ? resp.data : []
        this.list = Array.isArray(data) ? data : []
      } catch (e) {
        this.error = '加载失败，请稍后重试'
        // 留作真实接口错误处理示例
        // console.error(e)
        this.list = []
      } finally {
        this.loading = false
      }
    },
    toAbsoluteUrl(url) {
      if (!url) return '#'
      return /^(http|https):\/\//i.test(url) ? url : `http://${url}`
    }
  }
}
</script>

<style scoped>
.page {
  padding: 24px;
}

.card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.06);
  border: 1px solid #eef2f6;
  padding: 20px;
}

.title {
  margin: 0 0 12px;
  font-size: 20px;
  font-weight: 600;
  color: #1f2d3d;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.total {
  margin: 0 0 12px;
  font-size: 20px;
  font-weight: 600;
  color: #1f2d3d;
}

.table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.table thead th {
  text-align: left;
  font-weight: 600;
  color: #4a5568;
  padding: 12px 14px;
  background: #f8fafc;
  border-bottom: 1px solid #e5e9f2;
}

.table tbody td {
  padding: 12px 14px;
  border-bottom: 1px solid #f0f3f8;
  vertical-align: top;
}

.name {
  color: #2c3e50;
}

.record {
  color: #5a6a85;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.link {
  color: #2b7cff;
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}

.empty-cell {
  text-align: center;
  color: #8a94a6;
}

.muted {
  color: #8a94a6;
}
</style>
